const elements = {
  tables: document.querySelectorAll('table'),
};

function decodeHtml(html) {
  var txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}

function getTableHeadings(table) {
  const tableHeadings = [];
  const headerCells = table.rows[0].cells;

  for (let i = 0; i < headerCells.length; i += 1) {
    tableHeadings.push(headerCells[i].innerText.replace(/(^\s)|(^[&]nbsp[;])|(<[^>]+>)/g, ''));
  }

  return tableHeadings;
}

function addHeadingLabels(table, labels) {
  for (let r = 1, n = table.rows.length; r < n; r += 1) {
    for (let c = 0, m = table.rows[r].cells.length; c < m; c += 1) {
      table.rows[r].cells[c].innerHTML =
        '<div class="cell-content c-rte">' + table.rows[r].cells[c].innerHTML + '</div>';
      table.rows[r].cells[c].dataset.label = decodeHtml(labels[c]);

      if (table.rows[r].cells[c].dataset.label === 'undefined') {
        table.rows[r].cells[c].dataset.label = '';
      }
    }
  }
}

function init() {
  if (!elements.tables.length) {
    return;
  }

  elements.tables.forEach(table => {
    const headings = getTableHeadings(table);
    addHeadingLabels(table, headings);
  });
}

export default init;